import { render, staticRenderFns } from "./full-image.component.vue?vue&type=template&id=2383bed2&"
import script from "./full-image.component.vue?vue&type=script&lang=js&"
export * from "./full-image.component.vue?vue&type=script&lang=js&"
import style0 from "./full-image.component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports